export default __webpack_public_path__ + "static/media/403-image-2.e1bfa600.png";